import React from "react";
import { connect } from "react-redux";
import {
  Transition,
  Container,
  Segment,
  Header,
  Button
} from "semantic-ui-react";
import ActividadForm from "./shared/actividades/ActividadForm";
import { actividadesOps } from "../ducks/actividades";

class DetalleActividad extends React.Component {
  state = { visible: false };

  componentDidMount() {
    const {
      match: { params }
    } = this.props;
    this.setState({ visible: true });
    this.props.obtenerDetalleActividad(params.idActividad);
  }

  componentWillUnmount() {
    this.props.resetDetalleActividad();
  }

  handleVolver = () => this.props.history.goBack();

  handleNuevaActividad = () => this.props.history.push("/nueva/actividad");

  render() {
    return (
      <Transition.Group animation="scale" duration={250}>
        {this.state.visible && (
          <Container>
            <Segment basic>
              <Segment basic>
                <Button
                  icon="add"
                  color="pink"
                  floated="left"
                  content="Añadir Actividad"
                  onClick={this.handleNuevaActividad}
                />

                <Button
                  content="Cerrar"
                  floated="right"
                  color="pink"
                  icon="cancel"
                  onClick={this.handleVolver}
                />

                <Header inverted as="h2" textAlign="center">
                  Detalle de la Actividad
                </Header>
              </Segment>

              <ActividadForm
                initialValues={this.props.detalleActividad}
                action={values => this.props.updateDataActividad(values)}
              />
            </Segment>
          </Container>
        )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = state => ({
  detalleActividad: state.actividades.detalleActividad
});

const actions = {
  updateDataActividad: actividadesOps.updateDataActividad,
  obtenerDetalleActividad: actividadesOps.obtenerDetalleActividad,
  resetDetalleActividad: actividadesOps.resetDetalleActividad
};

export default connect(mapStateToProps, actions)(DetalleActividad);



// WEBPACK FOOTER //
// ./src/pages/DetalleActividad.jsx